import { useState } from "react";
import { useAuthConfig } from "../data/queries";
import { Wordmark } from "../ui/Brand";
import { TryDemoButton } from "./Demo";
import { PhoneSignIn } from "./LinkSignIn";
import { PasskeySignIn } from "./Passkeys";
import { Scenery } from "./Scenery";

const MESSAGES: Record<string, string> = {
  "not-allowed": "That Google account isn’t on this household’s list. Ask the household owner to add it in Settings → People.",
  failed: "Sign-in didn’t complete. Please try again.",
  "not-configured": "Sign-in isn’t available yet. Please try again later.",
};

export function SignIn() {
  const cfg = useAuthConfig();
  const params = new URLSearchParams(window.location.search);
  const reason = params.get("signin");
  params.delete("signin");
  // Back to the same page after Google, query included (/link?c=… needs its code).
  const query = params.toString();
  const returnTo = window.location.pathname + (query ? `?${query}` : "");
  // Approving a screen from the phone (app/LinkSignIn.tsx) starts here when the phone isn't signed in yet.
  const approving = window.location.pathname === "/link";
  // A phone can't scan its own screen.
  const [wide] = useState(() => window.matchMedia("(min-width: 721px)").matches);
  return (
    <div className="signin">
      <Scenery phase="dusk" condition="partly" season="autumn" moon={null} animate />
      <div className="signin-card">
        <Wordmark />
        {reason && MESSAGES[reason] && <p className="banner banner-error">{MESSAGES[reason]}</p>}
        {approving && <p>Sign in on this phone first, then you can sign in the screen.</p>}
        {cfg.data?.googleConfigured === false ? (
          <p className="muted">Sign-in isn’t available yet. Please try again later.</p>
        ) : (
          <a className="btn btn-primary btn-lg" href={`/api/auth/google/start?return=${encodeURIComponent(returnTo)}`}>
            Sign in with Google
          </a>
        )}
        <PasskeySignIn returnTo={returnTo} />
        <p className="muted small">Only members of this household can sign in.</p>
        {wide && !approving && cfg.data?.googleConfigured !== false && <PhoneSignIn returnTo={returnTo} />}
        {cfg.data?.demoAvailable && !approving && (
          <div className="signin-demo">
            <p className="muted small">Just looking? See Kinmantle with a sample family.</p>
            <TryDemoButton />
          </div>
        )}
        <p className="muted small signin-links">
          <a href="/about">About Kinmantle</a> · <a href="/privacy">Privacy</a>
        </p>
      </div>
    </div>
  );
}
